module.exports = __webpack_public_path__ + "static/media/keyman-db-banner-2@2x.0fb29b52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyman-db-banner-2@2x.png
// module id = 1285
// module chunks = 1